var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReferences(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#A43232",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.688 20.5a.563.563 0 0 1 .562-.562h9a.563.563 0 0 1 0 1.125h-9a.562.562 0 0 1-.563-.563zm9.562 3.938h-9a.563.563 0 0 0 0 1.125h9a.563.563 0 0 0 0-1.125zm0 4.5H29.5a.563.563 0 0 0 0 1.125h6.75a.563.563 0 0 0 0-1.125zm-9.394 1.922a.563.563 0 0 1-.403.684l-.14.019a.562.562 0 0 1-.544-.422 5.447 5.447 0 0 0-10.538 0 .563.563 0 0 1-1.087-.281 6.554 6.554 0 0 1 4.012-4.491 4.313 4.313 0 1 1 4.688 0 6.553 6.553 0 0 1 4.012 4.49zM20.5 25.938a3.188 3.188 0 1 0-3.188-3.188 3.197 3.197 0 0 0 3.188 3.188z",
    fill: "#A43232"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferences);
export default __webpack_public_path__ + "static/media/references.a032989123da60c172050099600df3b5.svg";
export { ForwardRef as ReactComponent };